import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import { FormField, AlertHelpDialog } from '@iris-platform/iris-react-ui';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {
  path,
  findIndex,
  propEq,
  append,
} from 'ramda';
import applicationPropType from '../applicationPropType';
// import { TeamContext } from '../../TeamProvider';
import {
  handleChange,
  stylesToPropType,
} from '../../../utils';
import Helpfile from '../helpfile.json';
import { PROTEKTOR_UPDATE } from '../../../utils/protektorConstants';

const styles = () => ({
  root: {
    width: '100%',
    marginLeft: '0px !important',
  },
  saveButton: {
    borderRadius: '0.125em',
    marginTop: '1em',
    width: '5em',
  },
  disabledField: {
    cursor: 'default',
    '& *': {
      color: '#606060',
    },
  },
  endAdornment: {
    marginRight: '0.5em',
  },
  // expiring: {
  //   position: 'relative',
  //   zIndex: 0,
  //   '& svg.timer': {
  //     zIndex: 0,
  //     position: 'absolute',
  //     top: '-0.63em',
  //     left: '-0.63em',
  //     height: '2.9em',
  //     width: '2.9em',
  //     transform: 'rotate(-90deg)',
  //     '& circle': {
  //       stroke: '#d2d2d28f',
  //       strokeWidth: '40',
  //       fill: 'none',
  //       strokeDasharray: '126 252',
  //       animation: `wipe ${SECRET_TTL_MS / 1000}s linear`,
  //     },
  //   },
  //   '& svg:not(.timer)': {
  //     zIndex: 1,
  //     position: 'sticky',
  //   },
  // },
  divider: {
    margin: '2em 0',
  },
  textField: {
    height: 'auto',
    paddingLeft: '0.5em',
    '&::before, &:hover::before': {
      display: 'none !important',
    },
  },
  button: {
    borderRadius: '0.125em',
    marginTop: '1em',
    marginRight: '0em',
    width: '8em',
  },
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
  resetContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& [class^="FormField"]': {
      flexGrow: '0.95',
    },
  },
  warning: {
    color: '#f50057',
  },
  '@keyframes wipe': {
    '0%': {
      strokeDashoffset: 0,
    },
    '100%': {
      strokeDashoffset: -126,
    },
  },
  switchContainer: {
    marginLeft: '24px',
  },
});

class SelfProvision extends Component {
  constructor(props) {
    super(props);

    const { application } = props;

    this.state = {
      application: {
        applicationID: application.applicationID,
        oauth2SelfProvisionDisabled:
          application.oauth2SelfProvisionDisabled === undefined
            ? false
            : application.oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled:
          application.oauth2EmailVerificationEnabled === undefined
            ? false
            : application.oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod:
          application.oauth2EmailVerificationGracePeriod === undefined
            ? '60'
            : application.oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration:
          application.oauth2EmailVerificationExpiration === undefined
            ? '0'
            : application.oauth2EmailVerificationExpiration,
      },
      pendingChanges: false,
      saving: false,
      title: 'User self provisioning',
      open: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  handleHelpOpen = (title, content) => {
    this.setState({
      open: true,
      dialogTitle: title,
      dialogContent: content,
    });
  };

  handleHelpClose = () => {
    this.setState({
      open: false,
      dialogTitle: '',
      dialogContent: '',
    });
  };

  // saveChanges = async () => {
  saveChanges = () => {
    const { ownerId, refreshApp, enqueueSnackbar } = this.props;
    const {
      application: {
        applicationID,
        oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration,
      },
    } = this.state;
    // const currentTeam = TeamContext.getSelectedTeamId();
    const currentTeam = ownerId;
    const application = {
      applicationID,
      oauth2SelfProvisionDisabled,
      oauth2EmailVerificationEnabled,
      oauth2EmailVerificationGracePeriod,
      oauth2EmailVerificationExpiration,
    };

    this.setState({ saving: true });

    refreshApp(application, currentTeam);

    enqueueSnackbar('User self provisioning updated', { variant: 'success' });

    this.setState({ pendingChanges: false });
    this.setState({ saving: false });
  }

  handleClientChange = (component, field, event) => {
    const {
      application: {
        applicationID,
        oauth2Providers,
      },
    } = this.state;

    const fieldValue = path(['target', 'value'], event);
    const provider = { ...component };
    provider[field] = fieldValue;
    let keyIndex = -1;
    if (oauth2Providers !== undefined && oauth2Providers !== null) {
      keyIndex = findIndex(propEq('type', provider.type))(oauth2Providers);
    }

    let providers = [];
    if (oauth2Providers !== undefined && oauth2Providers !== null && oauth2Providers !== []) {
      providers = [...oauth2Providers];
    }
    if (keyIndex >= 0) {
      providers[keyIndex] = provider;
    } else {
      providers = append(provider, providers);
    }
    this.setState({
      application: { applicationID, oauth2Providers: providers },
      pendingChanges: true,
    });
  };

  toggleProvisioning = () => {
    const {
      application: {
        applicationID,
        oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration,
      },
    } = this.state;
    this.setState({
      application: {
        applicationID,
        oauth2SelfProvisionDisabled: !oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration,
      },
    }, () => { this.saveChanges(); });
  }

  toggleEmail = () => {
    const {
      application: {
        applicationID,
        oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration,
      },
    } = this.state;
    this.setState({
      application: {
        applicationID,
        oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled: !oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration,
      },
    }, () => { this.saveChanges(); });
  }

  render() {
    const { classes } = this.props;
    const {
      application: {
        oauth2SelfProvisionDisabled,
        oauth2EmailVerificationEnabled,
        oauth2EmailVerificationGracePeriod,
        oauth2EmailVerificationExpiration,
      },
      title,
      saving,
      error,
      pendingChanges,
      open,
      dialogTitle,
      dialogContent,
    } = this.state;
    const help = Helpfile.oauth20;

    const { role } = this.props;

    return (
      <Fragment>
        <Typography
          component="div"
          variant="subheading"
          gutterBottom
        >
          {title}
          <IconButton className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.selfProvisioning.title, help.selfProvisioning.content)}>
            <HelpOutlineIcon className={classes.icon} />
          </IconButton>
        </Typography>
        <br />
        <Typography
          component="div"
          variant="caption"
          gutterBottom
        >
          Provisioning
        </Typography>

        <FormControlLabel
          control={(
            <Switch
              checked={!oauth2SelfProvisionDisabled}
              // onChange={() => { this.toggleEnabled(); }}
              onChange={() => { this.toggleProvisioning(); }}
              value="enable-selfprovision"
              color="primary"
              disabled={!role.hasPermission({ action: PROTEKTOR_UPDATE, resource: 'Application_OAuth2_Tab_Self_Provisioning' })}
            />
          )}
          label={oauth2SelfProvisionDisabled ? 'disabled' : 'enabled'}
        />
        <br />
        <Typography
          component="div"
          variant="caption"
          gutterBottom
        >
          Verification Email
        </Typography>

        <FormControlLabel
          control={(
            <Switch
              checked={oauth2EmailVerificationEnabled}
              // onChange={() => { this.toggleEnabled(); }}
              onChange={() => { this.toggleEmail(); }}
              value="enable-emailverification"
              color="primary"
            />
          )}
          label={oauth2EmailVerificationEnabled ? 'enabled' : 'disabled'}
        />
        <br />
        {
          oauth2EmailVerificationEnabled
            ? (
              <div>
                <Typography
                  component="div"
                  variant="caption"
                  gutterBottom
                >
                  Verification Email grace period (in minutes)
                  <FormControl className={classes.root} error={error}>
                    <FormField
                      placeholder="Email grace period (in minutes)"
                      inputClasses={{ input: classes.disabledField }}
                      value={oauth2EmailVerificationGracePeriod}
                      // disabled={!enabled}
                      // onChange={(event) => { this.handleClientChange(provider, 'clientID', event); }}
                      onChange={(event) => {
                        handleChange(this, ['application', 'oauth2EmailVerificationGracePeriod'])(event);
                        this.setState({ pendingChanges: true });
                      }}
                              />
                  </FormControl>
                </Typography>
                <br />
                <Typography
                  component="div"
                  variant="caption"
                  gutterBottom
                >
                  Verification Email expiration (in minutes)
                  <FormControl className={classes.root} error={error}>
                    <FormField
                      placeholder="Email expiration (in minutes)"
                      inputClasses={{ input: classes.disabledFieldng }}
                      value={oauth2EmailVerificationExpiration}
                      // disabled={!enabled}
                      // onChange={(event) => { this.handleClientChange(provider, 'clientSecret', event); }}
                      onChange={(event) => {
                        handleChange(this, ['application', 'oauth2EmailVerificationExpiration'])(event);
                        this.setState({ pendingChanges: true });
                      }}
                    />
                  </FormControl>
                </Typography>
                <br />
                <FormControl className={classes.root} error={error}>
                  <Button
                    variant="contained"
                    classes={{ root: classes.saveButton }}
                    disabled={!pendingChanges}
                    onClick={this.saveChanges}
                  >
                    Save
                  </Button>
                </FormControl>
              </div>
            ) : null
        }
        <AlertHelpDialog
          handleClose={this.handleHelpClose}
          open={open}
          dialogTitle={dialogTitle}
          dialogContent={dialogContent}
        />
      </Fragment>
    );
  }
}

SelfProvision.propTypes = {
  application: applicationPropType.isRequired,
  classes: stylesToPropType(styles()).isRequired,
  refreshApp: PropTypes.func.isRequired,
  ownerId: PropTypes.string.isRequired,
  role: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles)(SelfProvision));
